import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

// iter130 Phase A — password field with eye-toggle to show / hide the
// typed characters. Used on every password entry field across signup,
// login, and reset. Standard UX pattern; keeps password-manager and
// autofill compatibility because it swaps the input `type` attribute
// only (doesn't move focus or re-mount the element).
export default function PasswordInput({
  id,
  value,
  onChange,
  placeholder = "••••••••",
  required = false,
  autoComplete = "current-password",
  disabled = false,
  testId,
  className = "",
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        id={id}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        disabled={disabled}
        data-testid={testId}
        className={
          "pr-10 bg-transparent border-[var(--bt-border)] focus-visible:border-[var(--bt-accent)] " +
          "focus-visible:ring-1 focus-visible:ring-[var(--bt-accent)] h-11 " +
          className
        }
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid={testId ? `${testId}-toggle` : "password-visibility-toggle"}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-[var(--bt-text-muted)] hover:text-[var(--bt-text)] focus:outline-none"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
